<div>
  <h2>{{ title }}</h2>
  <h4>{{ subtitle }}</h4>
  <p>
    <span>{{ "there_are_no_completed_tasks" | localize }}</span>
    <button ui-button [buttonType]="'primary'" (click)="destroyModal()">destroy modal in the component</button>
  </p>
</div>
